import { DangerousIcon } from '@tom-ui/ui'
import { FC } from 'react'

export const IconDangerous: FC<{ zoom?: number; size?: number }> = ({ zoom, size }) => {
  return (
    <DangerousIcon
      sx={{
        height: `${size ?? 32}px`,
        width: `${size ?? 32}px`,
        transform: `scale(${(zoom ?? 100) / 100})`,
      }}
    />
  )
}

export default IconDangerous
